import { MenuItem, Paper, RaisedButton, SelectField, TextField } from 'material-ui';
import React, { useState } from 'react';
import '../LoginAsPage.scss';
import api from 'services';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addNotification } from 'actions/notifications/notifications';

const nameMapper = {
    oid2uuid: {
        name: 'ObjectId->uuid',
        from: 'ObjectId',
        to: 'uuid',
    },
    uuid2oid: {
        name: 'uuid->ObjectId',
        from: 'uuid',
        to: 'ObjectId',
    },
};

function IdsConverter({addNotification}) {
    const [current, setCurrent] = useState('uuid2oid');
    const [toConvert, setToConvert] = useState('');
    const [result, setResult] = useState('');

    const convert = async () => {
        if (!toConvert) return;
        const res = await api.idsConvert(current, toConvert);

        setResult(res);
    };

    const copy = () => {
        navigator.clipboard.writeText(result);
        addNotification({
            title: 'Success',
            message: 'Copied to clipboard',
            level: 'success',
            _id: new Date().getMilliseconds(),
            autoDismiss: 3,
        });
    };

    return (
        <Paper style={{ padding: '20px' }} zDepth={2} rounded={false} className="wrapper">
            <div>
                <h4>That block allows <code>ObjectId-{'>'}uuid</code> and <code>uuid-{'>'}ObjectId</code> conversion.</h4>

                <div className='converter-ops'>
                    <div className='manage'>
                        <SelectField
                            value={current}
                            onChange={(_e, _i, v) => setCurrent(v)}
                            style={{ fontSize: '13px', width: '30%' }}
                        >
                            <MenuItem value='uuid2oid' primaryText='uuid->ObjectId' />
                            <MenuItem value='oid2uuid' primaryText='ObjectId->uuid' />
                        </SelectField>
                        <RaisedButton label="Convert" primary onClick={convert} />
                    </div>
                    <div>
                        <TextField 
                            value={toConvert}
                            hintText={nameMapper[current].from}
                            onChange={e => setToConvert(e.target.value)}
                            style={{ fontSize: '13px' }}
                            onKeyDown={e => e.keyCode === 13 && convert}
                        />
                        {
                            result ?
                                <React.Fragment>
                                    <code style={{ color: 'gray' }}> {'-->'} </code>
                                    <span 
                                        role='button'
                                        style={{ cursor: 'pointer' }} 
                                        onClick={copy}
                                        tabIndex={0}
                                    >
                                        {result}
                                    </span>
                                </React.Fragment> : null
                        }
                    </div>
                </div>
            </div>
        </Paper>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(IdsConverter);



// WEBPACK FOOTER //
// ./app/components/LoginAsPage/IdsManipulators/IdsConverter.jsx